import vue from "vue";
import router from "vue-router";

import Start from "./views/Start";
import Login from "./views/Login";

vue.use(router);

export default new router({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "nu pr",
  linkExactActiveClass: "nu pr",
  routes: [
    {
      path: "/signout",
      name: "signout",
      component: () => import("./views/Signout")
    },
    {
      path: "/signup",
      name: "signup",
      component: () => {
        import("./views/Signup");
      }
    },
    {
      path: "/signin",
      name: "signin",
      component: Login
    },
    {
      path: "/resetpassword",
      name: "resetpassword",
      component: () => import("./views/Resetpassword.vue")
    },
    {
      path: "/resetpassword/:autoChallange",
      name: "newpassword",
      component: () => import("./views/Newpassword.vue")
    },
    {
      path: "/users",
      name: "users",
      component: () => import("./views/Users.vue")
    },
    {
      path: "/groups",
      name: "groups",
      component: () => import("./views/Groups.vue")
    },
    {
      path: "/roles",
      name: "roles",
      component: () => import("./views/Roles.vue")
    },
    {
      path: "/rules",
      name: "rules",
      component: () => import("./views/Rules.vue")
    },
    {
      path: "/projekt",
      name: "projekt",
      component: () => import("./views/Projects")
    },
    {
      path: "/projekt/:id",
      name: "projektdetaljer",
      component: () => import("./views/Project")
    },
    {
      path: "/om-oss/",
      name: "omoss",
      component: () => import("./views/About")
    },
    {
      path: "/",
      name: "home",
      component: Start
    },
    {
      path: "*",
      name: "404",
      component: () => import("./views/404")
    }
  ]
});
